const API_URLS = (import.meta.env.VITE_API_URLS || '').split(',').filter(Boolean);

if (API_URLS.length === 0) {
  // Fail loudly: a missing value otherwise surfaces as a blank page and an unrelated TypeError.
  throw new Error('VITE_API_URLS is not set. Copy .env.example to .env (REACT_APP_* vars were renamed to VITE_*).');
}

let currentZone = localStorage.getItem('zone') || API_URLS[0]; // Set to US AZ by default.

export function getAllZones() {
  return API_URLS;
}

export function getCurrentZone() {
  return currentZone;
}

export function setCurrentZone(zone) {
  localStorage.setItem('zone', zone);
  currentZone = zone;
}